<button
  [type]="btnField.type"
  [ngClass]="btnField.class"
  [disabled]="btnField.disabled"
  (click)="handleClick()"
  [class]="!!btnField.infoIconMessage ? 'info-width app-btn' : 'app-btn'"
  [class.has-spinner]="btnField.loading"
>
  <span class="loading-spinner" *ngIf="btnField.loading"></span>
  <em [ngClass]="btnField?.emClass" *ngIf="btnField?.emClass"></em>
  <img
    *ngIf="btnField?.prefixIconPath"
    appDisableRightClick
    appMobileOptimization
    [originalUrl]="btnField.prefixIconPath"
    [src]="btnField.prefixIconPath"
    [format]="'webp'"
    class="prefix-icon"
    height="20"
    width="20"
    alt="Icon"
    loading="lazy"
    decoding="async"
  />
  <ng-content></ng-content>
  <em
    *ngIf="btnField?.prefixIconClass"
    [ngClass]="btnField?.prefixIconClass"
  ></em>
  <span class="btn-text">{{ (btnField.loading && loadingLabel) ? loadingLabel : label }}</span>
</button>
<app-info-icon [message]="btnField.infoIconMessage"></app-info-icon>
